import React, { Component, FunctionComponent, useEffect, useState } from "react";
import { collection, getDocs, doc, query, where, QuerySnapshot } from "firebase/firestore";
import { bmServerCollectionName, db } from "../application/FirebaseConfigs";
import { EuiFlexItem, EuiButton, EuiFlexGroup } from "@elastic/eui";
import { ServerTable } from "./ServerTable";
import { BMServer } from "../model/BMServer";
import { UpdateServerModal } from "./UpdateServerModal";
import { AddServerModal } from "./AddServerModal";
import { BMServerTraffic } from "../model/BMServerTraffic";

interface IProps {
    traffic: BMServerTraffic
    servers: Map<String, BMServer>
    setServers: React.Dispatch<React.SetStateAction<Map<String, BMServer>>>
}

export const ServerSection: FunctionComponent<IProps> = (props) => {
    const [serverSnapShot, setServerSnapshot] = useState<QuerySnapshot>();
    const [showAddModal, setShowAddModal] = useState(false);

    const loadServers = () => {
        const q = query(collection(db, "" + bmServerCollectionName + ""), where("is_active", "==", true));
        getDocs(q).then((querySnapshot) => {
            setServerSnapshot(querySnapshot)
        }).finally(() => {

        })
    };

    useEffect(() => {
        loadServers();
    }, [])

    const showData = () => {
        if (serverSnapShot) {
            return (<>
                <ServerTable setServers={props.setServers} servers={props.servers} snapshot={serverSnapShot} traffic={props.traffic} />
                <div style={{ width: "100%", marginTop: "20px" }}>
                    <EuiFlexGroup>
                        <EuiFlexItem grow={false}>
                            <EuiButton onClick={() => setShowAddModal(true)}>Add New Server</EuiButton>
                        </EuiFlexItem>
                        <EuiFlexItem grow={true} >
                        </EuiFlexItem>
                        <EuiFlexItem grow={false} >
                            <UpdateServerModal showModal={false} onServerChange={s => { }} servers={props.servers} setServers={props.setServers} traffic={props.traffic} />
                        </EuiFlexItem>
                    </EuiFlexGroup>
                </div>
                {showAddModal && (
                    <AddServerModal
                        onClose={() => setShowAddModal(false)}
                        onServerAdded={() => {
                            loadServers(); // Refresh list
                        }}
                    />
                )}
            </>)
        } else {
            return (<div>Loading</div>)
        }
    }
    return (
        <div> {showData()} </div>
    );
}
